export var schema = {
  title: "Public Liability",
  description: "Public Liability Claim Form",
  type: "object",
  properties: {
    insured: {
      type: "object",
      title: "Insured",
      required: ["insuredName", "insuredPolicyNumber", "brokeremail"],
      properties: {
        insuredName: {
          type: "string",
          title: "Name of Insured"
        },
        insuredPolicyNumber: {
          type: "string",
          title: "Policy Number"
        },
        insuredContactPerson: {
          type: "string",
          title: "Contact Person"
        },
        insuredContactNumber: {
          type: "string",
          title: "Contact Phone Number"
        },
        insuredContactEmail: {
          type: "string",
          title: "Contact Email Address"
        },
        insuredVatNumber: {
          type: "string",
          title: "VAT Number"
        },
        brokeremail: {
          type: "string",
          title: "Broker Email",
          format: "email"
        }
      }
    },
    incident: {
      type: "object",
      title: "Incident",
      required: ["incidentdate"],
      properties: {
        incidentdate: {
          title: "Date of Incident",
          type: "string",
          format: "date-time"
        },
        incidentplace: {
          type: "string",
          title: "Place of Loss"
        },
        incidentestimate: {
          type: "string",
          title: "Estimate"
        },
        incidentisCovered: {
          type: "boolean",
          title: "Is this incident covered under any other policy of insurance?"
        }
      }
    },
    police: {
      type: "object",
      title: "Police",
      properties: {
        policeplaceReported: {
          title: "Place where Reported",
          type: "string"
        },
        policedateReported: {
          title: "Date of Reporting",
          type: "string",
          format: "date"
        },
        policecaseNumber: {
          title: "Case Number (If Reported)",
          type: "string"
        }
      }
    },
    witnesses: {
      type: "object",
      title: "Witnesses",
      properties: {
        witnessList: {
          title: "Witnesses",
          type: "array",
          items: {
            type: "object",
            properties: {
              witness: {
                type: "array",
                title: "Witness",
                items: [{
                  key: "name",
                  type: "string",
                  title: "Name"
                }, {
                  key: "string",
                  type: "string",
                  title: "Contact Number"
                }, {
                  key: "address",
                  type: "string",
                  title: "Address"
                }]
              }
            }
          }
        }
      }
    },
    propertyDamage: {
      type: "object",
      title: "Property Damage",
      properties: {
        propertyDamageName: {
          title: "Name of owner",
          type: "string"
        },
        propertyDamageAddress: {
          title: "Address of owner",
          type: "string"
        },
        propertyDamageDescription: {
          title: "Description of loss or damage",
          type: "string"
        }
      }
    },
    personalInjuries: {
      type: "object",
      title: "Personal Injuries",
      properties: {
        personalInjuriesList: {
          title: "Personal Injuries",
          type: "array",
          items: {
            type: "object",
            properties: {
              person: {
                type: "array",
                title: "Injured Person",
                items: [{
                  key: "name",
                  type: "string",
                  title: "Name"
                }, {
                  key: "string",
                  type: "string",
                  title: "Contact Number"
                }, {
                  key: "address",
                  type: "string",
                  title: "Address"
                }, {
                  key: "age",
                  type: "number",
                  title: "Age"
                }, {
                  key: "relationship",
                  title: "Relationships",
                  description: "If person named above is in your service, your tenant, or related to you, give full details",
                  type: "string"
                }]
              }
            }
          }
        }
      }
    },
    claims: {
      type: "object",
      title: "Claims",
      properties: {
        claimsDescription: {
          title: "Description",
          description: "If a claim has been, or is being made against you, give details and attach any correspondence.",
          type: "string"
        },
        claimsAttachment: {
          title: "Attachments",
          type: "array",
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        }
      }
    },
    eventDescription: {
      type: "object",
      title: "Description",
      properties: {
        relationshipsDescription: {
          title: "Description",
          type: "string"
        }
      }
    },
    declaration: {
      type: "object",
      title: "Declaration",
      required: ["insuredaccepttc"],
      description: "I/we declare that to the best of my / our knowledge the above statements are true. I acknowledge that the information set out above is provided freely so that Western may process my claim and give effect to the terms and conditions contained in the policy wording. I herewith give my consent that Western may use this information, my personal information on record and additional information obtained from other sources in order to determine whether to accept or reject my claim and take all necessary steps ancillary thereto to give effect hereto. I understand that I may be liable for output VAT in terms of section 8(8) of the VAT Act 89 of 1991.",
      properties: {
        insuredaccepttc: {
          type: "boolean",
          title: "Accept terms and conditions",
          description: "Tick box to accept terms and conditions"
        },
        insuredcapcity: {
          type: "string",
          title: "Capacity"
        },
        insureddate: {
          type: "string",
          title: "Date",
          format: "date"
        }
      }
    }
  }
};
export var uiSchema = {
  incidentplace: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  propertyDamageDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  relationshipsDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  claimsDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  eventDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  witnessList: {
    "ui:options": {
      orderable: false
    }
  },
  personalInjuriesList: {
    "ui:options": {
      orderable: false
    }
  }
};